/** @format */
import { observer } from 'mobx-react';
import React, { useState, useEffect } from 'react';
import {
  Button,
  Container,
  Divider,
  Form,
  Icon,
  Menu,
  Modal,
  Table,
} from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import CarsStore from '../../stores/CarsStore';
import RequestsStore from '../../stores/RequestsStore';
import SidebarStore from '../../stores/SidebarStore';
import database from '../../firebase/config';

export const InboundCars = observer(() => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [maker, setMaker] = useState(null);
  const [model, setModel] = useState(null);
  const [version, setVersion] = useState(null);
  const [loading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cars, setCars] = useState([]);
  const [notes, setNotes] = useState('');

  const history = useHistory();

  useEffect(() => {
    database.ref('inboundCars').on('value', snap => {
      const cars = [];

      snap.forEach(child => {
        cars.push({
          id: child.key,
          ...child.val(),
        });
      });

      setCars(cars);
    });

    return () => {
      database.ref('inboundCars').off();
    };
  }, []);

  useEffect(() => {
    if (maker) {
      CarsStore.fetchCarModels(maker.id);
    }
  }, [maker, CarsStore]);

  useEffect(() => {
    if (model) {
      CarsStore.fetchCarVersions(model.id);
    }
  }, [model, CarsStore]);

  function handleSubmit() {
    setIsLoading(true);
    setError(null);

    database
      .ref('inboundCars')
      .push({
        maker: maker.text,
        model: model.text,
        version: version ? version.text : null,
        notes,
      })
      .then(() => {
        setIsModalOpen(false);
      })
      .catch(err => {
        setError(err.message);
      })
      .finally(() => setIsLoading(false));
  }

  function handleRequestsClick(car) {
    history.push('/requests');
    SidebarStore.activeItem('requests');
    RequestsStore.searchRequest(`${car.maker} ${car.model}`);
  }

  function handleRemoval(key) {
    database.ref('inboundCars').child(key).remove();
  }

  return (
    <div>
      <Menu borderless>
        <Menu.Item position="right">
          <Button
            color="green"
            size="tiny"
            onClick={() => setIsModalOpen(!isModalOpen)}
          >
            <Icon name="plus" />
            Aggiungi auto
          </Button>
        </Menu.Item>
      </Menu>
      <Table sortable size="small" selectable className="app-manage-table">
        <Table.Header className="table-head">
          <Table.Row>
            <Table.HeaderCell>PRODUTTORE</Table.HeaderCell>
            <Table.HeaderCell>MODELLO</Table.HeaderCell>
            <Table.HeaderCell>VERSIONE</Table.HeaderCell>
            <Table.HeaderCell>NOTE</Table.HeaderCell>
            <Table.HeaderCell width="1" textAlign="center">
              RICHIESTE
            </Table.HeaderCell>
            <Table.HeaderCell width="1" textAlign="center">
              RIMUOVI
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {cars.length > 0 &&
            cars.map(car => (
              <Table.Row key={car.id}>
                <Table.Cell>{car.maker}</Table.Cell>
                <Table.Cell>{car.model}</Table.Cell>
                <Table.Cell>{car.version || '-'}</Table.Cell>
                <Table.Cell>{car.notes}</Table.Cell>
                <Table.Cell textAlign="center">
                  <Button
                    color="yellow"
                    icon="list"
                    onClick={() => handleRequestsClick(car)}
                  />
                </Table.Cell>
                <Table.Cell textAlign="center">
                  <Button
                    color="red"
                    icon="delete"
                    onClick={() => handleRemoval(car.id)}
                  />
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
      {cars.length === 0 && (
        <Container textAlign="center">Non ci sono nuove auto.</Container>
      )}

      <Modal onClose={() => setIsModalOpen(false)} open={isModalOpen}>
        <Modal.Header>Aggiunta auto</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Select
                search
                label="Produttore"
                options={CarsStore.carsMakers}
                onChange={(_, { value }) =>
                  setMaker(
                    CarsStore.carsMakers.find(maker => maker.value === value),
                  )
                }
              />
              <Form.Select
                search
                label="Modello"
                options={CarsStore.carsModels || []}
                onChange={(_, { value }) =>
                  setModel(
                    CarsStore.carsModels.find(model => model.value === value),
                  )
                }
              />
              <Form.Select
                search
                label="Versione"
                options={CarsStore.carsVersions || []}
                onChange={(_, { value }) =>
                  setVersion(
                    CarsStore.carsVersions.find(model => model.value === value),
                  )
                }
              />
            </Form.Group>
            <Form.TextArea
              label="Note"
              onChange={(_, { value }) => setNotes(value)}
            />
            <Divider />
            <Form.Button
              color="green"
              fluid
              onClick={handleSubmit}
              disabled={!model || loading}
              loading={loading}
            >
              Aggiungi auto
            </Form.Button>
            {error && <span style={{ color: 'red ' }}>{error}</span>}
          </Form>
        </Modal.Content>
      </Modal>
    </div>
  );
});
